export { default } from './AccordionItemLegacy';
